<template>
  <div
    class="container carousel carousel-slider"
    style="height: 220px; width: 40em;"
  >
    <slot></slot>
  </div>
</template>
<script>
import "materialize-css/dist/js/materialize.min";
import M from "materialize-css";

export default {
  name: "carousel-component",
  data() {
    return {
      instances: undefined
    };
  },
  mounted() {
    this.instance = this.initializeCarousel();
    this.AutoplayCarousel();
  },
  methods: {
    initializeCarousel(options = {}) {
      return M.Carousel.init(this.$el, options, {
        fullWidth: false,
        dist: 0
      });
    },

    AutoplayCarousel: function() {
      setInterval(() => {
        this.instance.next(1);
      }, 6500);
    }
  },
  watch: {},
  next() {
    this.instance.next();
  }
};
</script>
